import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRunBeforePushSubscription } from './useRunBeforePushSubscription';
import { checkEstimationExists } from '../../../actions/checkEstimationExists';
import { saveUserEstimation, submitValuationForm } from '../../../actions/submitValuationForm';
import { selectPushNotificationEnabled } from '../../../selectors/page';
import { selectFilters } from '../../../selectors/selectFilters';
import { TThunkDispatch } from '../../../types/redux';
import { useApplicationContext } from '../../../utils/applicationContext';

/**
 * Проверяем есть ли у нас оценка по заданному адресу,
 * если есть сабмитим форму и ведем на оценку,
 * если нет - показываем плашку "По данному адресу у нас оценки нет"
 */
export function useHandleAgentSubmit() {
  const dispatch = useDispatch<TThunkDispatch>();
  const { pushEnabled, estimationTarget } = useSelector(selectFilters);
  const pushNotificationEnabled = useSelector(selectPushNotificationEnabled);
  const runBeforePushSubscription = useRunBeforePushSubscription();
  const { config } = useApplicationContext();
  const requestPushAllowFeatureEnabled = config.get('requestPushAllowFeatureEnabled.Enabled');

  return React.useCallback(async () => {
    const isEstimationExists = await dispatch(checkEstimationExists());

    if (!isEstimationExists) {
      return;
    }

    let shouldSubscribeOnVal = pushEnabled && estimationTarget === EEstimationTargets.flat;
    const shouldPrepareBeforePushSubscription = !pushNotificationEnabled && requestPushAllowFeatureEnabled;

    if (shouldSubscribeOnVal && shouldPrepareBeforePushSubscription) {
      shouldSubscribeOnVal = await runBeforePushSubscription();
    }

    await dispatch(saveUserEstimation({ pushNeed: shouldSubscribeOnVal }));

    dispatch(submitValuationForm());
  }, [
    dispatch,
    estimationTarget,
    pushEnabled,
    pushNotificationEnabled,
    requestPushAllowFeatureEnabled,
    runBeforePushSubscription,
  ]);
}
